import React, { useEffect } from 'react';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Row, Col, Alert, Container } from 'reactstrap';

// availity-reactstrap-validation
import { AvForm, AvField } from 'availity-reactstrap-validation';

// action
import { registerUser, apiError, registerUserSuccessful } from '../../store/actions';

//redux
import { useSelector, useDispatch } from 'react-redux';

import { Link, useHistory } from 'react-router-dom';

// import images
import logo from '../../assets/images/logo-sm.svg';
import CarouselPage from '../AuthenticationInner/CarouselPage';
import getUrlParams from '../../components/Common/getUrlParams/getUrlParams';

const Register = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { url, brand, networkId } = getUrlParams({ name: 'nwkID' });

    const { user, registrationError, loading } = useSelector((state: any) => ({
        user: state.register.user,
        registrationError: state.register.registrationError,
        loading: state.register.loading,
    }));

    // handleValidSubmit
    const handleValidSubmit = (values: any) => {
        let tmpNetworkId = networkId != 0 && networkId != '' ? Number(networkId) : Number(0);
        const tmpNetworkId2 = values.network_id != 0 && values.network_id != '' ? Number(values.network_id) : Number(0);

        tmpNetworkId = tmpNetworkId ? tmpNetworkId : tmpNetworkId2;
        values = { ...values, network_id: tmpNetworkId };
        console.log(values);
        console.log("Window origine: ", window.location.origin);
        dispatch(registerUser({ ...values, url: window.location.origin }));
    };

    useEffect(() => {
        dispatch(apiError(''));
    }, [dispatch]);

    function createSuccessUser() {
        history.push('/login' + url);
        dispatch(registerUserSuccessful({ createUser: null }));
        return <Alert color="success">Register User Successfully</Alert>;
    }

    const LoadingIndicator = () => {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            <PageTitle>
                <title>Register | {brand.name}</title>
            </PageTitle>
            <div className="auth-page">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col lg={4} md={5} className="col-xxl-3">
                            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5 text-center">
                                            <Link to={url} className="d-block auth-logo">
                                                <img src={brand.logo} alt="" height="60" />{' '}
                                            </Link>
                                        </div>
                                        <div className="auth-content my-3">
                                            <div className="text-center">
                                                <h5 className="mb-0">Register Account</h5>
                                                <p className="text-muted mt-2">Get your free {brand.name} account now.</p>
                                            </div>
                                            <AvForm
                                                className="needs-validation custom-form mt-4 pt-2"
                                                onValidSubmit={(e: any, v: any) => {
                                                    handleValidSubmit(v);
                                                }}
                                            >
                                                {user && user ? createSuccessUser() : null}

                                                {registrationError && registrationError ? <Alert color="danger">{registrationError}</Alert> : null}

                                                <div className="mb-3">
                                                    <AvField
                                                        id="name"
                                                        name="name"
                                                        label="Name"
                                                        className="form-control"
                                                        placeholder="Enter name"
                                                        type="text"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <AvField
                                                        id="lastname"
                                                        name="lastname"
                                                        label="Last Name"
                                                        className="form-control"
                                                        placeholder="Enter lastname"
                                                        type="text"
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <AvField
                                                        id="email"
                                                        name="email"
                                                        label="Email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        required
                                                    />
                                                </div>
                                                {!networkId ? (
                                                    <div className="mb-3">
                                                        <AvField
                                                            id="network_id"
                                                            name="network_id"
                                                            label="Network ID"
                                                            className="form-control"
                                                            placeholder="Enter Network ID"
                                                            type="number"
                                                            required
                                                        />
                                                    </div>
                                                ) : null}
                                                <div className="mb-3">
                                                    <AvField name="password" label="Password" type="password" required placeholder="Enter Password" />
                                                </div>
                                                <div className="mb-4">
                                                    <p className="mb-0">
                                                        By registering you agree to the {brand.name}{' '}
                                                        <Link to={url} className="text-primary">
                                                            Terms of Use
                                                        </Link>
                                                    </p>
                                                </div>
                                                <div className="mb-3">
                                                    <button className="btn btn-primary w-100 waves-effect waves-light" type="submit">
                                                        Register
                                                    </button>
                                                </div>
                                            </AvForm>
                                            {loading ? LoadingIndicator() : null}

                                            <div className="mt-5 text-center">
                                                <p className="text-muted mb-0">
                                                    Already have an account ?{' '}
                                                    <Link to={'/login' + url} className="text-primary fw-semibold">
                                                        {' '}
                                                        Login{' '}
                                                    </Link>{' '}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="mt-4 mt-md-5 text-center">
                                            <p className="mb-0">
                                                © {new Date().getFullYear()} {' ' + brand.name}.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <CarouselPage />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Register;
